import printJS from 'print-js';

export const wordToPrint = (data: string) => {
  printJS({
    printable: data,
    type: 'pdf',
    showModal: true,
    modalMessage: ''
  });
};
